import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "basic-otp-input",
  ref: "basicOtpInputRef"
}
const _hoisted_2 = { class: "basic-otp-input-extra" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "prefix"),
      _createVNode(_component_a_input, _mergeProps({
        autocomplete: "off",
        type: "hidden",
        maxlength: _ctx.max,
        value: _ctx.innerValue,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValue) = $event))
      }, _ctx.$attrs, {
        ref: "basicOtpInputElement",
        autocorrect: "disabled",
        autocapitalize: "disabled",
        spellcheck: "false",
        inputmode: !!_ctx.numericOnly ? 'numeric' : 'text',
        pattern: !!_ctx.numericOnly ? _ctx.regex.otpNumericOnly : _ctx.regex.otpNonNumeric,
        onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.allowLatinSymbolsNumbers($event))),
        onDrop: _cache[2] || (_cache[2] = ($event: any) => (_ctx.allowLatinSymbolsNumbers($event))),
        onPaste: _cache[3] || (_cache[3] = ($event: any) => (_ctx.allowLatinSymbolsNumbers($event))),
        disabled: _ctx.loading
      }), null, 16, ["maxlength", "value", "inputmode", "pattern", "disabled"]),
      _createVNode(_component_v_otp_input, {
        ref: "vOtpInputRef",
        class: "basic-otp-input__wrapper",
        "input-classes": "basic-otp-input__input-slot",
        "num-inputs": _ctx.max,
        "should-auto-focus": true,
        "input-type": !!_ctx.numericOnly ? 'number' : 'letter-numeric',
        inputmode: !!_ctx.numericOnly ? 'numeric' : 'text',
        separator: "",
        autocomplete: "one-time-code",
        "is-disabled": _ctx.loading,
        onOnChange: _ctx.handleInternalOnChange,
        onPaste: _ctx.handleInternalOnPaste,
        onClick: _ctx.handleClick
      }, null, 8, ["num-inputs", "input-type", "inputmode", "is-disabled", "onOnChange", "onPaste", "onClick"]),
      _renderSlot(_ctx.$slots, "suffix"),
      _renderSlot(_ctx.$slots, "addonAfter")
    ], 512),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showDemoText)
        ? (_openBlock(), _createBlock(_component_a_typography_paragraph, {
            key: 0,
            class: "mt-16"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("For DEMO enter 11 11 11 to continue")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}